// #region Select Options
const buildingTypeOptions = [
  'Warehouse'
  , 'Light Industrial'
  , 'Manufacturing'
  , 'Distribution'
  , 'Refrigeration/Cold Storage'
  , 'Specialty'
];

const specialtyFeatureOptions = [
  "Transload"
  , "Industrial Park"
  , "Port"
  , "Foreign Trade Zone"
  , "Opportunity Zone"
];

const zoningOptions = [
  "Light Industrial"
  , "Medium Industrial"
  , "Heavy Industrial"
  , "Ag"
  , "Other"
];

const sortByOptions = [
  "Name A-Z"
  , "Name Z-A"
  , "SqFt High"
  , "SqFt Low"
  , "Closest Interstate"
];

// const reviewStatusOptions = [
// 	"Pending RE review"
// 	, "Pending MKTG review"
// 	, "Under review"
// 	, "Needs update"
// 	, "Publish"
// ];

// const cityOptionsTemp = [
//   "City A",
//   "City B",
//   "City C"
// ];

// const countyOptionsTemp = [
//   "County 1",
//   "County 2",
//   "County 3"
// ];

// let propertyLayerTableNames: string[] = [];

// #endregion

export { 
  buildingTypeOptions,
  specialtyFeatureOptions,
  zoningOptions,
  sortByOptions
};